import { render, staticRenderFns } from "./PayType.vue?vue&type=template&id=19c9968b&"
import script from "./PayType.vue?vue&type=script&lang=js&"
export * from "./PayType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports